export enum PRESCRIPTION_PROCESS_VIDEO_SRC {
  MP4 = '/media/videos/rezeptes.mp4',
  WEBM = '/media/videos/rezeptes.webm',
}
